import http from "../app/httpService";

const apiEndpoint = process.env.REACT_APP_MARKET_DATA_API + "indexBase/";

export async function getindexBases() {
  const { data: indexBases } = await http.get(apiEndpoint);
  return indexBases;
}

export async function getindexBase(indexBaseId) {
  const { data: indexBase } = await http.get(apiEndpoint + indexBaseId);
  return indexBase;
}

export async function getIndexBasesByMarket(
  marketId,
  marketDate,
  tomarketDate = null
) {
  const { data: indexBases } = await http.get(
    apiEndpoint +
      "byMarket/" +
      marketId +
      "/" +
      marketDate +
      "/" +
      tomarketDate ?? ""
  );
  return indexBases;
}

export async function getAggregateIndexBasesByMarket(
  marketId,
  marketDate,
  tomarketDate = null
) {
  const { data: indexBases } = await http.get(
    apiEndpoint +
      "aggregateByMarket/" +
      marketId +
      "/" +
      marketDate +
      "/" +
      tomarketDate ?? ""
  );
  return indexBases;
}

export async function addindexBase(indexBase) {
  const { data: IndexBase } = await http.post(apiEndpoint, indexBase);
  return IndexBase;
}

export async function updateindexBase(indexBase) {
  const { data: IndexBase } = await http.put(apiEndpoint, indexBase);
  return IndexBase;
}

export async function deleteindexBase(indexBase) {
  const { data: IndexBase } = await http.put(apiEndpoint + "delete", indexBase);
  return IndexBase;
}

export async function getindexBaseHistory(indexBaseId) {
  const { data: indexBaseHistory } = await http.get(
    apiEndpoint + "audit/" + indexBaseId
  );
  return indexBaseHistory;
}
